export default __webpack_public_path__ + "static/media/log.cd046e1a.svg";